"use client";
import React, { useEffect, useState } from "react";
import { CheckCircle, XCircle, AlertTriangle, Clock } from "lucide-react";
import { StatusModal } from "./StatusModal";
const StatusIcon = ({ status, onClick, }) => {
    const icon = (() => {
        switch (status) {
            case "available":
                return React.createElement(CheckCircle, { className: "text-green-500" });
            case "outage":
                return React.createElement(XCircle, { className: "text-red-500" });
            case "not_implemented":
                return React.createElement(AlertTriangle, { className: "text-yellow-500" });
            case "pending":
                return React.createElement(Clock, { className: "text-blue-500" });
            default:
                return null;
        }
    })();
    return (React.createElement("button", { onClick: onClick, className: `p-1 rounded-full hover:bg-gray-100 transition-colors ${status === "outage" ? "cursor-pointer" : "cursor-default"}` }, icon));
};
export function MonitoringDashboard() {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modal, setModal] = useState({
        isOpen: false,
        service: null,
    });
    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const response = await fetch("/api/monitor");
                if (!response.ok) {
                    throw new Error("Failed to fetch service status");
                }
                const data = await response.json();
                setServices(data);
            }
            catch (err) {
                setError(err instanceof Error ? err.message : "An error occurred");
            }
            finally {
                setLoading(false);
            }
        };
        fetchStatus();
        // Refresh every 5 minutes
        const interval = setInterval(fetchStatus, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);
    const handleStatusClick = (service) => {
        setModal({ isOpen: true, service });
    };
    if (loading) {
        return React.createElement("div", null, "Loading service status...");
    }
    if (error) {
        return React.createElement("div", { className: "text-red-500" },
            "Error: ",
            error);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "overflow-x-auto" },
            React.createElement("table", { className: "min-w-full bg-white border border-gray-200" },
                React.createElement("thead", null,
                    React.createElement("tr", { className: "bg-gray-50" },
                        React.createElement("th", { className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Service"),
                        React.createElement("th", { className: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status"))),
                React.createElement("tbody", { className: "bg-white divide-y divide-gray-200" }, services.map((service) => (React.createElement("tr", { key: service.name },
                    React.createElement("td", { className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" }, service.name),
                    React.createElement("td", { className: "px-6 py-4 whitespace-nowrap" },
                        React.createElement(StatusIcon, { status: service.status, onClick: () => handleStatusClick(service) })))))))),
        modal.service && (React.createElement(StatusModal, { isOpen: modal.isOpen, onClose: () => setModal({ isOpen: false, service: null }), serviceName: modal.service.name, status: modal.service.status, details: modal.service.details, url: modal.service.url, missingTags: modal.service.missingTags, foundTags: modal.service.foundTags, keyword: modal.service.keyword, context: modal.service.context, sitemapUrl: modal.service.sitemapUrl }))));
}
